import { Component, OnInit,ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from '../../../shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from '../../../shared/services/auth.service';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'ngx-reset-password-list',
  templateUrl: './reset-password-list.component.html',
  styleUrls: ['./reset-password-list.component.scss']
})
export class ResetPasswordListComponent implements OnInit {

  isDark: boolean = false;

  displayedColumns: string[] = ['email', 'username', 'requestDate','action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;

  resetRequest : any[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  constructor(
    private userService :UserService, 
    private router : Router, 
    private route : ActivatedRoute, 
    private toastr: ToastrService,
    private themeService: NbThemeService,
    private dialogService: DialogService,
    private authService: AuthService,
   ) { }

ngOnInit() {

    this.getAll();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

}

getControlPermissions(){
  var data = [];
   data =  this.authService.controlPermissionArray.filter((el)=>{
    return el.moduleCode ==='EXP'
  });
  if(data.length > 0){
    this.crud_access.read = data[0].read;
    this.crud_access.create = data[0].create;
    this.crud_access.approve = data[0].approve;
    this.crud_access.delete = data[0].delete;
  }
}

newButtonClick(){
  this.userService.resetRequestDataRow = null;  
  this.router.navigate(['/reset-password'],{relativeTo : this.route});
  }




  getAll(){
  this.userService.getAllRequestList()
   .subscribe(
      (data) => {
                this.resetRequest = data; 
                this.dataSource = new  MatTableDataSource (this.resetRequest);  
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;      
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  
    
   }
 


   getRowData(row){   
    this.userService.resetRequestDataRow = row;  
    this.router.navigate(['/reset-password'],{relativeTo : this.route});   
  }

   deleteButtonClick(id : number){   
     this.dialogService.openConfirmDialog('Are you sure you want to delete this request?')
     .afterClosed().subscribe(res =>{
       if(res){
      this.userService.deleteResetRequest(id)
      .subscribe(
        (res) => {
                    this.toastr.success('Deleted successfully','Success');
                    this.getAll();  
                  },        
        (err) =>  {
                    this.toastr.error('Failed to delete record','Failure');
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  }, 
          )

      } 
    });
 }


 applyFilter(){
  this.dataSource.filter =this.searchKey.trim().toLowerCase();

 }
 onSearchClear(){
   this.searchKey = "";
   this.applyFilter();
}



}//end class
